export const vestingSchedule = (state) => state.vestingSchedule;
export const esoOverview = (state) => state.esoOverview;
export const esopToken = (state) => state.esopToken;
export const esopOrder = (state) => state.esopOrder;
export const employeeInvite = (state) => state.employeeInvite;
export const allEmployeeInvites = (state) => state.allEmployeeInvites;
export const employeeInfo = (state) => state.employeeInfo;
export const employeeInvitePage = (state) => state.pageInfo.page;
export const employeeInvitePages = (state) => state.pageInfo.pages;